import React from 'react'

import { makeStyles } from '@material-ui/styles'
import { Popover, colors } from '@material-ui/core'

import { AccountProfile } from './components'

const useStyles = makeStyles(() => ({
  root: {
    width: 300,
    maxWidth: '100%'
  },
  actions: {
    backgroundColor: colors.grey[50],
    justifyContent: 'center'
  }
}))

const ProfilePopover = props => {
  const { notifications, anchorEl, ...rest } = props

  const classes = useStyles()

  return (
    <Popover
      {...rest}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center'
      }}
      style={{ marginTop: '1rem' }}>
      <div className={classes.root}>
        <AccountProfile />
      </div>
    </Popover>
  )
}

export default ProfilePopover
